import * as T from '@radix-ui/react-tabs';
import { cn } from '../../lib/utils.ts';

// shadcn/ui Tabs על Radix; הכיוון מגיע מ-DirectionProvider (rtl) — חיצי מקלדת מתהפכים.
// מראה: קו תחתון laser ללשונית הפעילה (צפוף, מתאים למסך עבודה); במובייל נגלל אופקית.
export const Tabs = T.Root;
export function TabsList({ className, ...p }: T.TabsListProps) {
  return (
    <T.List
      className={cn('flex max-w-full items-stretch gap-1 overflow-x-auto border-b border-border text-muted-foreground [scrollbar-width:none]', className)}
      {...p}
    />
  );
}
export function TabsTrigger({ className, ...p }: T.TabsTriggerProps) {
  return (
    <T.Trigger
      className={cn(
        'relative -mb-px inline-flex min-h-11 shrink-0 cursor-pointer items-center justify-center gap-2 border-b-2 border-transparent px-3 font-semibold transition-colors hover:text-foreground data-[state=active]:border-laser data-[state=active]:text-foreground',
        className,
      )}
      {...p}
    />
  );
}
export function TabsContent({ className, ...p }: T.TabsContentProps) {
  return <T.Content className={cn('mt-5 focus-visible:outline-none', className)} {...p} />;
}
